/**
 * Timeline Constants
 * 
 * This file contains all constant values used in the Timeline feature.
 */

/**
 * Color scheme for different timeline item types
 */
export const TIMELINE_COLORS = {
    note: '#2ca02c',     // Green
    careerCard: '#1f77b4', // Blue
    review: '#9467bd',   // Purple
    resume: '#ff7f0e',   // Orange
    workExperience: '#4a5568', // Professional slate gray
    file: '#17a2b8',     // Cyan
    retrospective: '#8c564b', // Brown
    default: '#718096'   // Default fallback color
} as const;

/**
 * Layout constants for timeline visualization
 */
export const TIMELINE_LAYOUT = {
    minHeight: 400,
    maxHeight: 800,
    minWidth: 1000,
    rowHeight: 35,
    rowSpacing: 5,
    itemPadding: 30,
    controlsHeight: 72,
    zoomLevels: {
        min: 0,
        max: 100,
        default: 0
    }
} as const;

/**
 * Time ranges for different zoom levels
 */
export const TIME_RANGES = {
    yearView: 24, // months
    monthView: 2,  // months
    weekView: 1    // month
} as const;

/**
 * Background gradient colors
 * Using a subtle blue-gray gradient that provides good contrast
 * while maintaining a professional appearance
 */
export const BACKGROUND_GRADIENT = {
    from: '#f8fafc', // Very light blue-gray
    to: '#f1f5f9'    // Slightly darker blue-gray
} as const;

/**
 * Animation durations in milliseconds
 */
export const ANIMATION_DURATIONS = {
    hover: 300,
    tooltip: 500,
    transition: 300
} as const;

/**
 * Default values for timeline state
 */
export const DEFAULT_VALUES = {
    position: {
        x: 0,
        y: 0,
        isNearRightEdge: false,
        isNearLeftEdge: false,
        isNearTopEdge: false
    },
    timelineRange: [0, 100] as [number, number],
    tooltipTimeout: 5000, // 5 seconds
    edgeThreshold: 150, // pixels from edge to trigger position adjustment
    minZoomSpan: 7 * 24 * 60 * 60 * 1000 // 1 week in milliseconds
} as const; 